var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        "append-to-body": true,
        title: _vm.$t("seller.informationDetails"),
        visible: _vm.infoDetailDialog,
        "custom-class": "drawerClass",
        direction: "ltr",
        size: "950px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.infoDetailDialog = $event
        },
        close: _vm.handleNewCodeDialog,
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            padding: "0 20px",
            "overflow-y": "auto",
            height: "calc(100vh - 100px)",
          },
        },
        [
          _c("div", { staticClass: "titleLabel" }, [
            _vm._v(_vm._s(_vm.$t("seller.invitationCodeInfo"))),
          ]),
          _c(
            "el-descriptions",
            { attrs: { colon: false, column: 4, direction: "vertical" } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("navbar.siteName") } },
                [_c("div", [_vm._v(_vm._s(_vm.rowObj.siteName || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("customerManagements.AccountName") } },
                [_c("div", [_vm._v(_vm._s(_vm.rowObj.userName || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                {
                  attrs: {
                    label: _vm.$t("receivablePayable.deliveryVehicleType"),
                  },
                },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.rowObj.deliveryVehicleType || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.deliveryPrice") } },
                [_c("div", [_vm._v(_vm._s(_vm.rowObj.deliveryPrice || "--"))])]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "titleLabel" }, [
            _vm._v(_vm._s(_vm.$t("seller.identityInfo"))),
          ]),
          _c(
            "el-descriptions",
            { attrs: { colon: false, column: 4, direction: "vertical" } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("collectionCenter.theDriverName") } },
                [_c("div", [_vm._v(_vm._s(_vm.identityInfo.realName || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.cnpjNumber") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.identityInfo.cnpjNumber || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.CPFNumber") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.identityInfo.cpfNumber || "--")),
                  ]),
                ]
              ),
              _c("el-descriptions-item", { attrs: { label: "ANTT-RNTRC" } }, [
                _c("div", [_vm._v(_vm._s(_vm.identityInfo.anttRntrc || "--"))]),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "titleLabel" }, [
            _vm._v(_vm._s(_vm.$t("seller.fileImages"))),
          ]),
          _c(
            "el-descriptions",
            { attrs: { colon: false, column: 3, direction: "vertical" } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: "Documentos e Licenças" } },
                [
                  _vm.fileUpload.documentsAndLicenses
                    ? _c(
                        "div",
                        {
                          staticClass: "demo-image__preview",
                          staticStyle: { "z-index": "9999" },
                        },
                        _vm._l(
                          _vm.fileUpload.documentsAndLicensesList,
                          function (item2, index2) {
                            return _c("el-image", {
                              key: index2,
                              staticStyle: {
                                width: "100px",
                                "margin-right": "5px",
                              },
                              attrs: {
                                "preview-src-list": [item2],
                                src: item2,
                                fit: "contain",
                              },
                            })
                          }
                        ),
                        1
                      )
                    : _c("div", [_vm._v("--")]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Comprovante de propriedade do veículo" } },
                [
                  _vm.fileUpload.proofOfVehicleOwnership
                    ? _c(
                        "div",
                        {
                          staticClass: "demo-image__preview",
                          staticStyle: { "z-index": "9999" },
                        },
                        _vm._l(
                          _vm.fileUpload.shipList,
                          function (item2, index2) {
                            return _c("el-image", {
                              key: index2,
                              staticStyle: {
                                width: "100px",
                                "margin-right": "5px",
                              },
                              attrs: {
                                "preview-src-list": [item2],
                                src: item2,
                                fit: "contain",
                              },
                            })
                          }
                        ),
                        1
                      )
                    : _c("div", [_vm._v("--")]),
                ]
              ),
              _c("el-descriptions-item", { attrs: { label: "CNH" } }, [
                _vm.fileUpload.cnh
                  ? _c(
                      "div",
                      {
                        staticClass: "demo-image__preview",
                        staticStyle: { "z-index": "9999" },
                      },
                      _vm._l(_vm.fileUpload.cnhList, function (item2, index2) {
                        return _c("el-image", {
                          key: index2,
                          staticStyle: {
                            width: "100px",
                            "margin-right": "5px",
                          },
                          attrs: {
                            "preview-src-list": [item2],
                            src: item2,
                            fit: "contain",
                          },
                        })
                      }),
                      1
                    )
                  : _c("div", [_vm._v("--")]),
              ]),
              _c("el-descriptions-item", { attrs: { label: "CRLV" } }, [
                _vm.fileUpload.crlv
                  ? _c(
                      "div",
                      {
                        staticClass: "demo-image__preview",
                        staticStyle: { "z-index": "9999" },
                      },
                      _vm._l(_vm.fileUpload.crlvList, function (item2, index2) {
                        return _c("el-image", {
                          key: index2,
                          staticStyle: {
                            width: "100px",
                            "margin-right": "5px",
                          },
                          attrs: {
                            "preview-src-list": [item2],
                            src: item2,
                            fit: "contain",
                          },
                        })
                      }),
                      1
                    )
                  : _c("div", [_vm._v("--")]),
              ]),
              _c(
                "el-descriptions-item",
                {
                  attrs: {
                    label:
                      "Comprovante de residência válido nos últimos 90 dias",
                  },
                },
                [
                  _vm.fileUpload.proofOfResidenceValidWithin90Days
                    ? _c(
                        "div",
                        {
                          staticClass: "demo-image__preview",
                          staticStyle: { "z-index": "9999" },
                        },
                        _vm._l(
                          _vm.fileUpload.Days90List,
                          function (item2, index2) {
                            return _c("el-image", {
                              key: index2,
                              staticStyle: {
                                width: "100px",
                                "margin-right": "5px",
                              },
                              attrs: {
                                "preview-src-list": [item2],
                                src: item2,
                                fit: "contain",
                              },
                            })
                          }
                        ),
                        1
                      )
                    : _c("div", [_vm._v("--")]),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "titleLabel" }, [
            _vm._v(_vm._s(_vm.$t("GlobalSetObj.Bankinformation"))),
          ]),
          _c(
            "el-descriptions",
            { attrs: { colon: false, column: 4, direction: "vertical" } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.bankName") } },
                [_c("div", [_vm._v(_vm._s(_vm.bankInfo.bank || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.agent") } },
                [_c("div", [_vm._v(_vm._s(_vm.bankInfo.agent || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("GlobalSetObj.bankAccount") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.bankInfo.bankCardNumber || "--")),
                  ]),
                ]
              ),
              _c("el-descriptions-item", { attrs: { label: "PIX" } }, [
                _c("div", [_vm._v(_vm._s(_vm.bankInfo.pix || "--"))]),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "titleLabel" }, [
            _vm._v(_vm._s(_vm.$t("seller.driverInfo"))),
          ]),
          _c(
            "el-descriptions",
            { attrs: { colon: false, column: 4, direction: "vertical" } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("orderDetails.zipcode") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverZipCode || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("driver.modalStreet") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverStreet || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.districtNeighborhood") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverNeighborhood || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.buildingNumber") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverBuildingNumber || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("placeOrder.Complement") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverSupplement || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("orderDetails.City") } },
                [_c("div", [_vm._v(_vm._s(_vm.driverInfo.driverCity || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("placeOrder.State") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverState || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.driverFullName") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverFullName || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.rgNumber") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverRGNumber || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.idIssuingState") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverIdentityState || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.dateOfBirth") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverBirthDate || "--")),
                  ]),
                ]
              ),
              _c("el-descriptions-item", { attrs: { label: "PIS" } }, [
                _c("div", [_vm._v(_vm._s(_vm.driverInfo.driverPis || "--"))]),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.fatherName") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverFatherName || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.motherName") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverMotherName || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("collectionCenter.phoneNumber") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverMobileNumber || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("orderCenterCont.telephoneNumber") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverPhoneNumber || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("orderDetails.email") } },
                [_c("div", [_vm._v(_vm._s(_vm.driverInfo.email || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.maritalStatus") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.driverInfo.driverMaritalStatus || "--")),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "titleLabel" }, [
            _vm._v(_vm._s(_vm.$t("seller.documentInfo"))),
          ]),
          _c(
            "el-descriptions",
            { attrs: { colon: false, column: 4, direction: "vertical" } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.driverLicenseNumber") } },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.documentsInfo.driverCertificateNumber || "--")
                    ),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.licenseFirstIssueDate") } },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.documentsInfo.certificateFirstDate || "--")
                    ),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.expiryDate") } },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.documentsInfo.certificateExpireDate || "--")
                    ),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.licenseIssuingState") } },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.documentsInfo.driverCertificateState || "--")
                    ),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.licenseType") } },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.documentsInfo.driverCertificateType || "--")
                    ),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.securityCode") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.documentsInfo.safetyCode || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Renach Licences" } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.documentsInfo.renachLicences || "--")),
                  ]),
                ]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "titleLabel" }, [
            _vm._v(_vm._s(_vm.$t("seller.vehicleInfo"))),
          ]),
          _c(
            "el-descriptions",
            { attrs: { colon: false, column: 4, direction: "vertical" } },
            [
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("collectionCenter.carType") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleType || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.licensePlateNumber") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleNumber || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.vinNumber") } },
                [_c("div", [_vm._v(_vm._s(_vm.vehicleInfo.vin || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.vehicleBody") } },
                [_c("div", [_vm._v(_vm._s(_vm.vehicleInfo.bodyworks || "--"))])]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("Resource.vehicleBrand") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleBrand || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.vehicleManufactureYear") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleCreateYear || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.vehicleModelYear") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleModelYear || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("Resource.vehicleModel") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleModel || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.vehicleColor") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleColour || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                {
                  attrs: { label: _vm.$t("seller.vehicleRegistrationNumber") },
                },
                [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.vehicleInfo.vehicleRegistrationNumber || "--")
                    ),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                {
                  attrs: {
                    label: _vm.$t("seller.licensePlateRegistrationCity"),
                  },
                },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleNumberCity || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.licensePlateState") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleNumberState || "--")),
                  ]),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: _vm.$t("seller.vehicleOwner") } },
                [
                  _c("div", [
                    _vm._v(_vm._s(_vm.vehicleInfo.vehicleOwnerName || "--")),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm.vehicleOwnerInfo
            ? _c("div", { staticClass: "titleLabel" }, [
                _vm._v(_vm._s(_vm.$t("seller.ownerInfo"))),
              ])
            : _vm._e(),
          _vm.vehicleOwnerInfo
            ? _c(
                "el-descriptions",
                { attrs: { colon: false, column: 4, direction: "vertical" } },
                [
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("seller.ownerFullName") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerFullName || "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("seller.ownerCpf") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.vehicleOwnerInfo.vehicleOwnerCpf || "--")
                        ),
                      ]),
                    ]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "RG" } }, [
                    _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.vehicleOwnerInfo.vehicleOwnerRgNumber || "--"
                        )
                      ),
                    ]),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("seller.ownerIdIssueState") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerIDState || "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("seller.ownerFatherFullName") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerFatherFullName ||
                              "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("seller.ownerMotherFullName") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerMotherFullName ||
                              "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    {
                      attrs: { label: _vm.$t("collectionCenter.phoneNumber") },
                    },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerPhoneNumber || "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("newOrder.ZipCode") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerZipCode || "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("base.address") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerAddress || "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("placeOrder.HouseNumber") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerHouseNumber || "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("seller.districtNeighborhood") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerNeighborhood ||
                              "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("placeOrder.Complement") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            _vm.vehicleOwnerInfo.vehicleOwnerSupplement || "--"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("orderDetails.City") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.vehicleOwnerInfo.vehicleOwnerCity || "--")
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: _vm.$t("placeOrder.State") } },
                    [
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.vehicleOwnerInfo.vehicleOwnerState || "--")
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }